import styled from 'styled-components';

export const ActionsContainer = styled.div`
  margin-left: 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;

  ${ActionsContainer} {
    display: none;
  }

  &:hover ${ActionsContainer} {
    display: initial;
  }
`;
